import { useId } from "react";

import mockData from "mock/frequently-words";

import Container from "components/grid/container";

import styles from "./styles.module.css";

const FrequentlyWords = () => {
  const id = useId();
  return (
    <div className={styles.wrapper}>
      <Container>
        <h2 className={styles.title}>Sık Aranan Kelimeler</h2>
        <ul className={styles.list}>
          {mockData.map((item, index) => (
            <li key={`${id}+${index}`}>
              <a href={`${item.slug}`}>{item.value}</a>
            </li>
          ))}
        </ul>
      </Container>
    </div>
  );
};

export default FrequentlyWords;
